<template lang='pug'>
div
  page-error(v-if="state.error")
  breadcrumbs-layout(
    v-else
    :breadcrumbs="crumbs"
  )
    VerifyEmailText(
      link-text="Перейти в ЦОПП"
      :messageData="messageData"
      :linkPath="{path: '/'}"
    )
</template>

<script>
import PageError from '@/pages/404.vue';
import {
  Breadcrumbs as BreadcrumbsLayout,
} from 'elysium-common/components/layout';
import VerifyEmailText from '@/components/parts/verify/email';

import createStoreModule from './store.js';
import breadcrumbMixin from '@/pages/breadcrumb-mixin.js';
import routeProps from '@/mixins/routeProps.js';

import {
  PAGE_TITLE,
  DESCRIPTION,
  KEYWORDS,
  SUCCESS_TITLE,
  SUCCESS_MESSAGE,
  ERROR_TITLE,
  ERROR_MESSAGE,
} from './const.js';

const STORE_MODULE_NAME = 'verify_email';

export default {
  name: 'PageVerifyEmail',

  storeName: STORE_MODULE_NAME,

  storeRegister: createStoreModule,

  mixins: [
    breadcrumbMixin,
    routeProps,
  ],

  components: {
    PageError,
    BreadcrumbsLayout,
    VerifyEmailText,
  },

  asyncData({store}) {
    return store.dispatch(`${STORE_MODULE_NAME}/init`);
  },

  data: () => ({
    success_data: {
      title: SUCCESS_TITLE,
      message: SUCCESS_MESSAGE,
    },

    error_data: {
      title: ERROR_TITLE,
      message: ERROR_MESSAGE,
    },
  }),

  computed: {
    crumbs() {
      return this.breadcrumbs.concat([{text: PAGE_TITLE}]);
    },

    state() {
      return this.$store.state[STORE_MODULE_NAME];
    },

    messageData() {
      const {state, success_data, error_data} = this;
      return state.success ? success_data : error_data;
    },
  },
  metaInfo() {
    return {
      title: PAGE_TITLE,
      meta: [
        {vmid: 'description', name: 'description', content: DESCRIPTION},
        {vmid: 'keywords', name: 'keywords', content: KEYWORDS},
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Email.vue?832040bc